<igx-card class="main" elevated>
    <igx-card-header>
        <p>{{program?.name}}</p>
    </igx-card-header>
    <igx-card-content class="main">
        <igx-grid [data]="programs">
            <igx-column field="product" header="Продукт" [sortable]="true"></igx-column>
            <igx-column field="sport" header="Спорт" [sortable]="true"></igx-column>
            <igx-column field="level" header="Ниво" [sortable]="true"></igx-column>
            <igx-column field="description" header="Дати" [sortable]="true"></igx-column>
            <igx-column field="date" dataType="date" header="Дата" [sortable]="true"></igx-column>
            <igx-column field="minAge" header="Мин." [sortable]="true"></igx-column>
            <igx-column field="maxAge" header="Макс" [sortable]="true"></igx-column>
            <igx-column field="duration" header="Продължителност" [sortable]="true"></igx-column>
            <igx-column field="capacity" header="Капацитет" [sortable]="true"></igx-column>
            <igx-column field="price" header="Цена" [sortable]="true"></igx-column>
        </igx-grid>
    </igx-card-content>
    <igx-card-actions>
        <button igxEnd igxButton igxRipple (click)="done.emit()">Затвори</button>
    </igx-card-actions>
</igx-card>